
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5T7BQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $db56f67ff489629b$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $db56f67ff489629b$export$2e2bcd8739ae039 = {
    'navigation.global-shortcuts.all-sites': 'Alle websites',
    'navigation.global-shortcuts.apps.align': 'Juster',
    'navigation.global-shortcuts.apps.analytics': 'Analyser',
    'navigation.global-shortcuts.apps.assets': 'Aktiver',
    'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
    'navigation.global-shortcuts.apps.company-hub': 'Virksomhedshub',
    'navigation.global-shortcuts.apps.compass': 'Compass',
    'navigation.global-shortcuts.apps.confluence': 'Confluence',
    'navigation.global-shortcuts.apps.focus': 'Focus',
    'navigation.global-shortcuts.apps.goals': "M\xe5l",
    'navigation.global-shortcuts.apps.home': 'Startside',
    'navigation.global-shortcuts.apps.jira': 'Jira',
    'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
    'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
    'navigation.global-shortcuts.apps.loom': 'Loom',
    'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
    'navigation.global-shortcuts.apps.projects': 'Projekter',
    'navigation.global-shortcuts.apps.studio': 'Studio',
    'navigation.global-shortcuts.apps.talent': 'Talent',
    'navigation.global-shortcuts.apps.teams': 'Teams',
    'navigation.global-shortcuts.apps.trello': 'Trello',
    'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': 'Luk',
    'navigation.global-shortcuts.menu-expand-item.site-aria-label': '{name}-website',
    'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': "(ikke tilg\xe6ngelig i \xf8jeblikket)",
    'navigation.global-shortcuts.menu-link-item.link-external-item-label': "Ikon for \xe5bning af eksternt link",
    'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': "(indl\xe6ser)",
    'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': "(indl\xe6ser)",
    'navigation.global-shortcuts.shortcut-action.open-menu-label': "\xe5bn menu",
    'navigation.global-shortcuts.sites': '{productName}-websites'
};

});


//# sourceMappingURL=da.f791f53a.js.map
